function Modal({ children, title, isShowing, hide, id, buttons }) {
    if (!isShowing[id]) return;
    return (
        <div id={id} class="d-block modal show" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{title}</h5>
                        <button id={"toggle" + id} type="button" class="btn-close" data-dismiss="modal" aria-label="Close" onClick={hide} />
                    </div>
                    <div class="modal-body">
                        {children}
                    </div>
                    <div class="modal-footer">
                        {
                            buttons && buttons.map( button => 
                                <button type="button" class={"btn " + button.className} onClick={button.onClick}>{button.text}</button>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal;